import { useContext } from "react";

import {
  type INotificationsContext,
  NotificationsContext,
} from "../context/NotificationsContext";

export const useNotificationsDrawer = (): INotificationsContext => {
  const context = useContext(NotificationsContext);

  /* istanbul ignore next */
  if (!context) {
    throw new Error(
      "useNotificationsDrawer must be used within a NotificationsProvider",
    );
  }

  return context;
};
